import React, { useState, useCallback } from 'react'

import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'

import { StParagraphs, StAvatar, StSep1 } from './style.css'

import StrapiComponents from '@/components/StrapiComponents'

const Page = ({ pagedata }) => {
  const { title, slug, content } = pagedata

  return (
    <div className="mx-auto text-center">
      <div className="bg-white pt-4 sm:col-span-8 col-span-12 row-span-2 max-w-screen-md mx-auto">
        <h2>{title}</h2>
        {content && (
          <div className="mx-auto text-left p-8">
            {content.map((component, index) => (
              <StrapiComponents key={index} component={component} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Page
